(function () {
  function parseMetafields(raw) {
    var map = {};
    if (!raw) return map;
    raw.split('|').forEach(function (part) {
      var split = part.split(':');
      if (split.length < 2) return;
      var stocks = split[1].split(',');
      map[split[0]] = {
        uae: parseInt(stocks[0]),
        qatar: parseInt(stocks[1]),
        kuwait: parseInt(stocks[2]),
        policy: stocks[3]
      };
    });
    return map;
  }

  function getVariantId() {
    var input = document.querySelector('form[action*="cart"] input[name="id"]');
    return input ? input.value : null;
  }

  function getAddToCartBtn() {
    return document.querySelector('form[action*="cart"] button[name="add"]') ||
           document.querySelector('form[action*="cart"] button[type="submit"]');
  }

  function applyStockUI(market, metafields) {
    market = window.wtMarket || market;
    var variantId = getVariantId();
    if (!variantId) return;

    var mf = metafields[variantId];
    var stock = window.wtGetStock(market, mf);
    if (stock === null || stock === undefined) return;

    var btn = getAddToCartBtn();
    var msgId = 'wt-oos-msg';
    var existing = document.getElementById(msgId);

    var inventoryElForNotice = document.querySelector('product-inventory');
    var preorderEnabledForNotice = false;
    if (inventoryElForNotice) {
      if (market === 'uae') {
        preorderEnabledForNotice = inventoryElForNotice.getAttribute('data-wt-preorder-uae') === 'true';
      } else if (market === 'qatar') {
        preorderEnabledForNotice = inventoryElForNotice.getAttribute('data-wt-preorder-qatar') === 'true';
      } else if (market === 'kuwait') {
        preorderEnabledForNotice = inventoryElForNotice.getAttribute('data-wt-preorder-kuwait') === 'true';
      }
    }
    if (preorderEnabledForNotice && mf && mf.policy !== 'continue') preorderEnabledForNotice = false;

        var notice = document.querySelector('.js-inventory-notice');
    if (notice) {
      if (stock <= 0) {
        notice.textContent = preorderEnabledForNotice ? 'Pre-Order' : 'Out of stock';
        notice.setAttribute('data-inventory-level', preorderEnabledForNotice ? 'preorder' : 'no_stock');
      } else if (stock <= 3) {
        notice.textContent = 'Only ' + stock + ' left';
        notice.setAttribute('data-inventory-level', 'very_low');
      } else if (stock <= 10) {
        notice.textContent = stock + ' Low stock';
        notice.setAttribute('data-inventory-level', 'low');
      } else {
        notice.textContent = stock + ' In stock';
        notice.setAttribute('data-inventory-level', 'normal');
      }
      notice.style.visibility = 'visible';
    }

    if (stock <= 0) {
      var buyNowBtn = document.querySelector('.shopify-payment-button');
      if (buyNowBtn) buyNowBtn.style.display = 'none';

      var inventoryEl = document.querySelector('product-inventory');
      var preorderEnabled = false;
      var preorderNote = '';

      if (inventoryEl) {
        if (market === 'uae') {
          preorderEnabled = inventoryEl.getAttribute('data-wt-preorder-uae') === 'true';
          preorderNote = inventoryEl.getAttribute('data-wt-preorder-note-uae') || '';
        } else if (market === 'qatar') {
          preorderEnabled = inventoryEl.getAttribute('data-wt-preorder-qatar') === 'true';
          preorderNote = inventoryEl.getAttribute('data-wt-preorder-note-qatar') || '';
        } else if (market === 'kuwait') {
          preorderEnabled = inventoryEl.getAttribute('data-wt-preorder-kuwait') === 'true';
          preorderNote = inventoryEl.getAttribute('data-wt-preorder-note-kuwait') || '';
        }
      }

      if (preorderEnabled && mf && mf.policy !== 'continue') preorderEnabled = false;

      if (preorderEnabled) {
        if (btn) {
          btn.disabled = false;
          if (!btn.getAttribute('data-wt-orig')) btn.setAttribute('data-wt-orig', btn.innerHTML);
          btn.innerHTML = '<span>Pre-Order Now</span>';
        }
        if (!existing && btn) {
          var msg = document.createElement('p');
          msg.id = msgId;
          msg.style.cssText = 'color:#cc0000;font-size:13px;margin-top:6px;text-align:center;';
          msg.textContent = preorderNote;
          btn.closest('form')
            ? btn.closest('form').insertAdjacentElement('afterend', msg)
            : btn.parentNode.insertBefore(msg, btn.nextSibling);
        }
      } else {
        if (btn) {
          btn.disabled = true;
          if (!btn.getAttribute('data-wt-orig')) btn.setAttribute('data-wt-orig', btn.innerHTML);
          btn.innerHTML = '<span>Out of Stock</span>';
        }
        if (!existing && btn) {
          var msg = document.createElement('p');
          msg.id = msgId;
          msg.style.cssText = 'color:#cc0000;font-size:13px;margin-top:6px;text-align:center;';
          msg.textContent = 'Out of stock.';
          btn.closest('form')
            ? btn.closest('form').insertAdjacentElement('afterend', msg)
            : btn.parentNode.insertBefore(msg, btn.nextSibling);
        }
      }
    } else {
      if (btn) {
        btn.disabled = false;
        var orig = btn.getAttribute('data-wt-orig');
        if (orig) btn.innerHTML = orig;
      }
      if (existing) existing.remove();
      var buyNowBtn = document.querySelector('.shopify-payment-button');
      if (buyNowBtn) buyNowBtn.style.display = '';
    }
  }

  function watchButton(market, metafields) {
    market = window.wtMarket || market;
    var btn = getAddToCartBtn();
    if (!btn) return;

    var isUpdating = false;
    new MutationObserver(function() {
      if (isUpdating) return;
      var variantId = getVariantId();
      if (!variantId) return;
      var mf = metafields[variantId];
      var stock = window.wtGetStock(market, mf);
      if (stock !== null && stock <= 0) {
        var inventoryEl = document.querySelector('product-inventory');
        var preorderEnabled = false;
        if (inventoryEl) {
          if (market === 'uae') preorderEnabled = inventoryEl.getAttribute('data-wt-preorder-uae') === 'true';
          else if (market === 'qatar') preorderEnabled = inventoryEl.getAttribute('data-wt-preorder-qatar') === 'true';
          else if (market === 'kuwait') preorderEnabled = inventoryEl.getAttribute('data-wt-preorder-kuwait') === 'true';
        }
        if (preorderEnabled && mf && mf.policy !== 'continue') preorderEnabled = false;

        isUpdating = true;
        if (preorderEnabled) {
          btn.disabled = false;
          btn.innerHTML = '<span>Pre-Order Now</span>';
        } else {
          if (!btn.disabled) {
            btn.disabled = true;
            btn.innerHTML = '<span>Out of Stock</span>';
          }
        }
        setTimeout(function() { isUpdating = false; }, 200);
      }
    }).observe(btn, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
  }

  function initProductPage(market) {
    var inventoryEl = document.querySelector('product-inventory');
    if (!inventoryEl) return;

    var raw = inventoryEl.getAttribute('data-wt-metafields');
    if (!raw) return;

    var metafields = parseMetafields(raw);

    applyStockUI(market, metafields);
    watchButton(market, metafields);

    var input = document.querySelector('form[action*="cart"] input[name="id"]');
    if (input) {
      new MutationObserver(function() {
        setTimeout(function() {
          applyStockUI(market, metafields);
          watchButton(market, metafields);
        }, 100);
      }).observe(input, { attributes: true, attributeFilter: ['value'] });

      input.addEventListener('change', function() {
        setTimeout(function() { applyStockUI(market, metafields); }, 100);
      });
    }

    document.addEventListener('variant:changed', function() {
      setTimeout(function() { applyStockUI(market, metafields); }, 150);
    });

    setInterval(function() {
      applyStockUI(market, metafields);
    }, 3000);
  }

  function initCards(market) {
    var cards = document.querySelectorAll('[data-wt-card-metafields]');
    cards.forEach(function(card) {
      var raw = card.getAttribute('data-wt-card-metafields');
      if (!raw) return;

      var metafields = {};
      raw.split('|').forEach(function(part) {
        var split = part.split(':');
        if (split.length < 2) return;
        var stocks = split[1].split(',');
        metafields[split[0]] = {
          uae: parseInt(stocks[0]),
          qatar: parseInt(stocks[1]),
          kuwait: parseInt(stocks[2]),
          policy: stocks[3]
        };
      });

      function updateCardBadge(variantId) {
        var market = window.wtMarket;
        var mf = metafields[variantId];
        var badge = card.querySelector('.product-inventory__status');
        if (!badge) return;
        if (!mf || (isNaN(mf.uae) && isNaN(mf.qatar) && isNaN(mf.kuwait))) return;
        var stock = window.wtGetStock(market, mf);
        if (stock === null) return;
        if (stock <= 0) {
          var preorderAttr = 'data-wt-preorder-' + market;
          var isPreorder = card.getAttribute(preorderAttr) === 'true' && mf.policy === 'continue';
          badge.textContent = isPreorder ? 'Pre-Order' : 'Out of stock';
          badge.setAttribute('data-inventory-level', isPreorder ? 'preorder' : 'no_stock');
        } else if (stock <= 3) {
          badge.textContent = 'Only ' + stock + ' left';
          badge.setAttribute('data-inventory-level', 'very_low');
        } else if (stock <= 10) {
          badge.textContent = 'Only ' + stock + ' left';
          badge.setAttribute('data-inventory-level', 'low');
        } else {
          badge.textContent = stock + ' In stock';
          badge.setAttribute('data-inventory-level', 'normal');
        }
        badge.style.visibility = 'visible';
      }

      function runUpdate() {
        var checkedInput = card.querySelector('.js-option:checked');
        var firstInput = card.querySelector('.js-option');
        var activeInput = checkedInput || firstInput;
        if (activeInput) {
          updateCardBadge(activeInput.getAttribute('data-variant-id'));
        } else {
          var firstKey = Object.keys(metafields)[0];
          if (firstKey) updateCardBadge(firstKey);
        }
      }

      setTimeout(runUpdate, 100);
      setTimeout(runUpdate, 500);
      setTimeout(runUpdate, 1000);

      card.querySelectorAll('.js-option').forEach(function(input) {
        input.addEventListener('change', function() {
          updateCardBadge(this.getAttribute('data-variant-id'));
        });
      });

      setInterval(runUpdate, 3000);

    });
  }

  function init() {
    window.wtGetMarket(function(market) {
      window.wtMarket = market;
      initProductPage(market);
      initCards(market);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Recently viewed re-init
  var rvEl = document.querySelector('recently-viewed');
  if (rvEl) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0 && window.wtMarket) {
          initCards(window.wtMarket);
        }
      });
    }).observe(rvEl, { childList: true, subtree: true });
  }

})();